import { Component, OnInit, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpParams } from "@angular/common/http";

import { ApiCallingService } from "../../services/api-calling.service";
import { ConfigApi } from "../../config-api";
import { ToastrService } from "ngx-toastr";
import { NgForm } from "@angular/forms";
import { Globals } from "../../common/global";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import { IDropdownSettings } from "ng-multiselect-dropdown";

@Component({
  selector: "app-vending",
  templateUrl: "./vending.component.html",
  styleUrls: ["./vending.component.css"],
})
export class VendingComponent implements OnInit {
  @ViewChild("productform", { static: true }) productform: NgForm =
    Object.create(null);

  operatorDetails: any;
  modeltitle: any;
  page = 1;
  pageSize = 5;
  data: any;
  totalcount = 0;
  detail: any;
  imageModal: {
    isBarcode?: boolean;
    image: string;
  } = Object.create(null);
  imageUrl: any;
  currency: any;
  productImageRequired: boolean = false;
  locationRequired: boolean = false;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100];
  searchQuery: string = "";
  shipmentDropdownSettings: IDropdownSettings = {};
  shipmentDropdownList: any[] = [];
  selectedShipments: any[] = [];

  allowedShipments = ["pickup", "delivery", "expressdelivery"];
  private searchDebounceTimer: any;

  private mapboxAccessToken = environment.mapbox.accessToken;
  showMapModal: boolean = false;
  map: any;
  marker: any;
  lat: number = 0;
  lng: number = 0;
  selectedLatitude: number = 0;
  selectedLongitude: number = 0;
  addressRequiredError: boolean = false;

  productFields = {
    productImage: null,
    productImageFile: null,
    latitude: 0,
    longitude: 0,
    price: 0,
    oldPrice: 0,
    vat: null,
    isExclusive: true,
    name: "",
    description: "",
    visible: false,
    isFeatured: false,
    address: "",
    barcodeImage: null,
    barcodeImageFile: null,
    EANNumber: "",
    stockQuantity: 1,
    totalSold: 0,
    weight: null,
  };
  dropdownSettings: IDropdownSettings = {};
  dropdownList: any[] = [];
  selectedItems: any[] = [];
  categoryList: any;

  constructor(
    private modalService: NgbModal,
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    public Globals: Globals,
    private router: Router,
  ) {
    let user = this.Globals.getUser();
    this.operatorDetails = user;
    let isEmployee = this.Globals.getIsEmployee();
    this.currency =
      isEmployee === "true"
        ? user?.operator_id?.countryObject?.currency
        : user.countryObject.currency;
  }

  ngOnInit(): void {
    this.getVendingProducts();
    this.getProductCategory();

    this.dropdownSettings = {
      singleSelection: false,
      idField: "_id",
      textField: "category_name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: false,
    };

    // ===== Shipment dropdown settings =====
    this.shipmentDropdownSettings = {
      singleSelection: false,
      idField: "key",
      textField: "label",
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      itemsShowLimit: 3,
      allowSearchFilter: false,
      closeDropDownOnSelection: false,
    };

    this.shipmentDropdownList = [
      { key: "pickup", label: "Pickup" },
      { key: "delivery", label: "Delivery" },
      { key: "expressdelivery", label: "Express Delivery" },
    ];

    // ===== Default selected shipments =====
    this.selectedShipments = this.shipmentDropdownList.filter((item) =>
      this.allowedShipments.includes(item.key),
    );
  }

  onShipmentSelect() {
    this.syncAllowedShipments();
  }

  onShipmentDeSelect() {
    this.syncAllowedShipments();
  }

  onShipmentSelectAll(items: any[]) {
    this.selectedShipments = [...items];
    this.syncAllowedShipments();
  }

  onShipmentDeSelectAll() {
    this.selectedShipments = [];
    this.syncAllowedShipments();
  }

  private syncAllowedShipments() {
    this.detail.allowedShipments = this.selectedShipments.map((s) => s.key);
  }

  onSearchChange() {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
    this.searchDebounceTimer = setTimeout(() => {
      this.page = 1;
      this.getVendingProducts();
    }, 500);
  }

  getProductCategory() {
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.VENDING_CATEGORY.LIST_WITHOUT_PAGENATION +
          "?operator_id=" +
          this.operatorDetails._id,
      )
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.categoryList = res.data;
          this.dropdownList = [...this.categoryList];
        }
      });
  }

  openImageModal(targetModal: NgbModal, imageUrl: any, isBarcode: boolean) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
      size: "md",
    });
    this.imageModal = {
      isBarcode: isBarcode,
      image: imageUrl,
    };
  }

  openModal(targetModal: NgbModal, data: any, title: any) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
      size: "lg",
    });

    this.modeltitle = title;
    this.detail = Object.assign({}, data, {
      isCampaign: data.isCampaign ?? false,
      isFestiveBox: data.isFestiveBox ?? false,
    });
    this.productImageRequired = false;
    this.locationRequired = false;

    if (Object.keys(data).length === 0) {
      // ===== ADD PRODUCT =====
      this.detail = {
        productImage: null,
        productImageFile: null,
        barcodeImage: null,
        barcodeImageFile: null,
        latitude: 0,
        longitude: 0,
        price: null,
        oldPrice: 0,
        vat: null,
        isExclusive: true,
        name: "",
        description: "",
        visible: false,
        isFeatured: false,
        address: "",
        EANNumber: "",
        stockQuantity: 1,
        totalSold: 0,
        categoryIds: [],
        weight: null,
        allowedShipments: ["pickup", "delivery", "expressdelivery"], // ✅ default
        isCampaign: false,
        isFestiveBox: false,
      };

      this.selectedItems = [];

      this.selectedShipments = this.shipmentDropdownList.filter((item) =>
        this.detail.allowedShipments.includes(item.key),
      );
    } else {
      // ===== EDIT / VIEW / DELETE =====

      // ---------- CATEGORY ----------
      if (title === "Edit Product") {
        if (data.categoryIds && data.categoryIds.length > 0) {
          const categoryIdsArray = data.categoryIds.map((cat: any) =>
            typeof cat === "string" ? cat : cat._id,
          );

          this.selectedItems = this.categoryList.filter((cat: any) =>
            categoryIdsArray.includes(cat._id),
          );

          this.detail.categoryIds = categoryIdsArray;
          this.detail.oldPrice = this.detail.oldPrice ?? 0;
        } else {
          this.selectedItems = [];
          this.detail.categoryIds = [];
        }
      } else if (title === "View Product" || title === "Delete Product") {
        if (data.categoryIds && data.categoryIds.length > 0) {
          if (typeof data.categoryIds[0] === "string") {
            this.detail.categoryIds = this.categoryList.filter((cat: any) =>
              data.categoryIds.includes(cat._id),
            );
          }
        }
      }

      // ---------- ✅ SHIPMENTS ----------
      if (data.allowedShipments && data.allowedShipments.length > 0) {
        this.selectedShipments = this.shipmentDropdownList.filter((item) =>
          data.allowedShipments.includes(item.key),
        );
        this.detail.allowedShipments = [...data.allowedShipments];
      } else {
        this.selectedShipments = [];
        this.detail.allowedShipments = [];
      }
    }
  }

  onBarcodeImageChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.detail.barcodeImageFile = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.detail.barcodeImage = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  closeBtnClick() {
    this.modalService.dismissAll();
    this.showMapModal = false;
    this.addressRequiredError = false;
    this.productImageRequired = false;
    this.locationRequired = false;
  }

  closeMapModal() {
    this.showMapModal = false;
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  confirmLocation() {
    if (this.selectedLatitude && this.selectedLongitude) {
      this.lat = this.selectedLatitude;
      this.lng = this.selectedLongitude;
      this.detail.latitude = this.selectedLatitude;
      this.detail.longitude = this.selectedLongitude;
      this.locationRequired = false;

      this.closeMapModal();
      this.toastr.success("Location selected successfully");
    } else {
      this.toastr.error("Please select a location on the map");
    }
  }

  getVendingProducts() {
    let user_id = this.Globals.user._id;
    const pageIndex = this.page > 0 ? this.page - 1 : 0;
    let params = new HttpParams()
      .set("operator_id", user_id)
      .set("page", pageIndex.toString())
      .set("limit", this.pageSize.toString());
    if (this.searchQuery) {
      params = params.set("name", this.searchQuery);
    }
    this.apiCallingService
      .callAPI({}, "GET", ConfigApi.URLS.VENDING.LIST + "?" + params.toString())
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.data = res?.data;
          this.totalcount = res.total;
        }
      });
  }

  onPageSizeChange() {
    this.page = 1;
    this.loadPage(this.page);
  }

  loadPage(page: number) {
    if (page) {
      this.page = page;
      this.getVendingProducts();
    }
  }

  trackById(index: number, item: any) {
    return item._id; // must be unique
  }

  delete(): void {
    this.apiCallingService
      .callAPI(
        {},
        "DELETE",
        ConfigApi.URLS.VENDING.DELETE + "/" + this.detail._id,
      )
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.toastr.success("Product successfully deleted");
          this.closeBtnClick();
          this.ngOnInit();
        }
      });
  }

  onItemSelect(item: any) {
    this.detail.categoryIds = this.selectedItems.map((cat) => cat._id);
  }

  onItemDeSelect(item: any) {
    this.detail.categoryIds = this.selectedItems.map((cat) => cat._id);
  }

  onSubmit(f: any) {
    this.productImageRequired = false;
    this.locationRequired = false;
    this.syncAllowedShipments();

    let errors: string[] = [];

    if (!f.valid) {
      Object.keys(f.controls).forEach((key) => {
        f.controls[key].markAsTouched();
      });
    }

    if (!this.detail.productImage && this.modeltitle === "Add Product") {
      this.productImageRequired = true;
      errors.push("Product image is required");
    }

    if (f.value.stockQuantity < 0) {
      errors.push("Stock Quantity must be at least 1");
    }

    if (f.value.price <= 0) {
      errors.push("Price is Required");
    }
    if (f.value.oldPrice < 0) {
      errors.push("Old Price must be greater than or equal to 0");
    }
    if (
      !this.detail.allowedShipments ||
      this.detail.allowedShipments.length === 0
    ) {
      errors.push("At least one shipment option is required");
    }

    if (errors.length > 0) {
      return;
    }

    let body = new FormData();

    body.append("operator_id", this.Globals.user._id);
    body.append("name", f.value.name);
    body.append("description", f.value.description || "");
    body.append("price", f.value.price.toString());
    body.append("oldPrice", (f.value.oldPrice || 0).toString());
    body.append("vat", f.value.vat.toString());
    body.append("isExclusive", f.value.isExclusive.toString());
    body.append("visible", this.detail.visible);
    body.append("isFeatured", this.detail.isFeatured);
    body.append("isCampaign", this.detail.isCampaign);
    body.append("isFestiveBox", this.detail.isFestiveBox);
    body.append("EANNumber", this.detail.EANNumber);
    body.append("stockQuantity", this.detail.stockQuantity);
    body.append("categoryIds", JSON.stringify(this.detail.categoryIds));
    body.append(
      "weight",
      this.detail.weight ? this.detail.weight.toString() : "",
    );
    body.append(
      "allowedShipments",
      JSON.stringify(this.detail.allowedShipments),
    );
    if (
      this.modeltitle === "Edit Product" &&
      this.detail.totalSold !== undefined
    ) {
      body.append("totalSold", this.detail.totalSold.toString());
    }
    if (this.detail.productImageFile) {
      body.append("productImage", this.detail.productImageFile);
    }
    if (this.detail.barcodeImageFile) {
      body.append("barcodeImage", this.detail.barcodeImageFile);
    }

    let url = ConfigApi.URLS.VENDING.CREATE;
    let method = "POST";

    if (this.modeltitle == "Edit Product") {
      url = ConfigApi.URLS.VENDING.UPDATE + "/" + this.detail._id;
      method = "PUT";
    }

    this.apiCallingService.callAPI(body, method, url).subscribe(
      (res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.toastr.success(res.msg || "Product saved successfully");
          this.closeBtnClick();
          this.ngOnInit();
        } else {
          this.toastr.error(res.msg || "Error saving product");
        }
      },
      (err) => {
        console.error(err);
        this.toastr.error(err.error?.msg || "Error occurred", "Error");
      },
    );
  }
  downloadSampleCSV() {
    const link = document.createElement("a");
    link.href = "assets/SampleVendingCSV.csv";
    link.download = "sample-product-template.csv";
    link.click();
  }

  onImageChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.detail.productImageFile = file;
      this.productImageRequired = false;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.detail.productImage = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  uploadProductsFromCSV(event: any) {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files?.[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        const csvText = e.target.result as string;

        if (!file.name.toLowerCase().endsWith(".csv")) {
          this.toastr.error(
            "Invalid file type. Please upload a .csv file.",
            "Error",
          );
          fileInput.value = "";
          return;
        }

        if (csvText.startsWith("PK")) {
          this.toastr.error(
            "It looks like you uploaded an Excel (.xlsx) file with a .csv extension. Please save the file as 'CSV (Comma delimited)' in Excel and try again.",
            "Invalid File Content",
            { timeOut: 10000 },
          );
          fileInput.value = "";
          return;
        }

        let cleanText = csvText;
        if (cleanText.charCodeAt(0) === 0xfeff) {
          cleanText = cleanText.slice(1);
        }

        const parseCSV = (text: string): string[][] => {
          const result: string[][] = [];
          let row: string[] = [];
          let current = "";
          let inQuotes = false;

          for (let i = 0; i < text.length; i++) {
            const char = text[i];
            const nextChar = text[i + 1];

            if (char === '"') {
              if (inQuotes && nextChar === '"') {
                current += '"';
                i++;
              } else {
                inQuotes = !inQuotes;
              }
            } else if (char === "," && !inQuotes) {
              row.push(current.trim());
              current = "";
            } else if ((char === "\n" || char === "\r") && !inQuotes) {
              if (char === "\r" && nextChar === "\n") {
                i++;
              }
              row.push(current.trim());
              result.push(row);
              row = [];
              current = "";
            } else {
              current += char;
            }
          }
          if (current || row.length > 0) {
            row.push(current.trim());
            result.push(row);
          }
          return result;
        };

        const rows = parseCSV(cleanText);

        if (rows.length === 0) {
          this.toastr.error("CSV file is empty");
          fileInput.value = "";
          return;
        }

        // Parse headers
        const headers = rows[0].map((h) => h.trim().replace(/^"|"$/g, ""));

        console.log("Headers found:", headers);
        console.log("Total columns:", headers.length);

        const requiredFields = [
          "name",
          "description",
          "price",
          "vat",
          "isExclusive",
        ];

        const fieldIndices: any = {};
        requiredFields.forEach((field) => {
          const index = headers.findIndex(
            (h) => h.toLowerCase() === field.toLowerCase(),
          );
          fieldIndices[field] = index;
          console.log(`Field '${field}' is at index: ${index}`);
        });

        const missingHeaders = requiredFields.filter(
          (field) => fieldIndices[field] === -1,
        );

        if (missingHeaders.length > 0) {
          this.toastr.error(
            `Missing required headers: ${missingHeaders.join(", ")}`,
          );
          fileInput.value = "";
          return;
        }

        const errors: string[] = [];
        const validRows: any[] = [];

        // Process each data row
        for (let i = 1; i < rows.length; i++) {
          const row = rows[i];

          // Skip if all cells are empty
          const hasAnyData = row.some((cell) => cell && cell.trim() !== "");
          if (!hasAnyData) {
            continue;
          }

          const rowObj: any = {};

          // Map data using correct column indices
          requiredFields.forEach((field) => {
            const index = fieldIndices[field];
            rowObj[field] = (row[index] || "").trim().replace(/^"|"$/g, "");
          });

          // Debug log for problematic rows
          if (i >= 827 && i <= 842) {
            console.log(`Row ${i + 1}:`, {
              name: rowObj.name,
              price: rowObj.price,
              vat: rowObj.vat,
              isExclusive: rowObj.isExclusive,
              totalCells: row.length,
            });
          }

          // Check if row has actual product data (at least name or description)
          if (!rowObj.name && !rowObj.description) {
            continue;
          }

          const rowNumber = i + 1;
          let rowHasErrors = false;

          // Validate name
          if (!rowObj.name || rowObj.name === "") {
            errors.push(`Row ${rowNumber}: 'name' is required`);
            rowHasErrors = true;
          }

          // Validate description
          if (!rowObj.description || rowObj.description === "") {
            errors.push(`Row ${rowNumber}: 'description' is required`);
            rowHasErrors = true;
          }

          // Validate price
          if (!rowObj.price || rowObj.price === "") {
            errors.push(`Row ${rowNumber}: 'price' is required`);
            rowHasErrors = true;
          } else {
            const priceValue = rowObj.price.replace(/[^\d.-]/g, ""); // Remove any currency symbols
            if (isNaN(Number(priceValue)) || Number(priceValue) < 0) {
              errors.push(
                `Row ${rowNumber}: 'price' must be a valid positive number`,
              );
              rowHasErrors = true;
            }
          }

          // Validate VAT
          if (!rowObj.vat || rowObj.vat === "") {
            errors.push(`Row ${rowNumber}: 'vat' is required`);
            rowHasErrors = true;
          } else {
            const vatValue = Number(rowObj.vat);
            if (isNaN(vatValue) || vatValue < 0 || vatValue > 100) {
              errors.push(`Row ${rowNumber}: 'vat' must be between 0 and 100`);
              rowHasErrors = true;
            }
          }

          // Validate isExclusive
          if (!rowObj.isExclusive || rowObj.isExclusive === "") {
            errors.push(`Row ${rowNumber}: 'isExclusive' is required`);
            rowHasErrors = true;
          } else {
            const exclusiveValue = rowObj.isExclusive.toLowerCase();
            if (exclusiveValue !== "true" && exclusiveValue !== "false") {
              errors.push(
                `Row ${rowNumber}: 'isExclusive' must be 'true' or 'false' (found: '${rowObj.isExclusive}')`,
              );
              rowHasErrors = true;
            }
          }

          if (!rowHasErrors) {
            validRows.push(rowObj);
          }
        }

        console.log(`Total valid rows: ${validRows.length}`);
        console.log(`Total errors: ${errors.length}`);

        if (errors.length > 0) {
          // Show first 30 errors
          const displayErrors = errors.slice(0, 30);
          const errorMessage = displayErrors.join("<br>");
          const additionalMsg =
            errors.length > 30
              ? `<br><br>... and ${errors.length - 30} more errors`
              : "";

          this.toastr.error(
            errorMessage + additionalMsg,
            `CSV Validation Errors (${errors.length} total)`,
            {
              enableHtml: true,
              timeOut: 15000,
            },
          );
          fileInput.value = "";
          return;
        }

        if (validRows.length === 0) {
          this.toastr.error("No valid data rows found in CSV");
          fileInput.value = "";
          return;
        }

        const formData = new FormData();
        formData.append("csv_file", file);
        formData.append("operator_id", this.Globals.user._id);

        this.apiCallingService
          .callAPI(formData, "POST", ConfigApi.URLS.VENDING.UPLOAD_CSV)
          .subscribe(
            (res) => {
              if (this.apiCallingService.handleSuccess(res)) {
                this.toastr.success(
                  res.msg ||
                    `CSV uploaded successfully (${validRows.length} products)`,
                );
                this.ngOnInit();
              } else {
                this.toastr.error(res.msg || "Error uploading CSV");
                this.ngOnInit();
              }
              fileInput.value = "";
            },
            (err) => {
              this.toastr.error(
                err.error?.msg || "Error uploading CSV",
                "Error",
              );
              fileInput.value = "";
              this.ngOnInit();
            },
          );
      };

      reader.readAsText(file);
    }
  }

  toggleProductVisibility(product: any) {
    const body = {
      visible: product.visible,
    };

    this.apiCallingService
      .callAPI(
        body,
        "POST",
        ConfigApi.URLS.VENDING.TOGGLE_VISIBILITY + "/" + product._id,
      )
      .subscribe(
        (res) => {
          console.log("✅ API Response:", res);
          if (this.apiCallingService.handleSuccess(res)) {
            const status = product.visible ? "visible" : "invisible";
            this.toastr.success(`Product ${status} successfully`);
          }
        },
        (err) => {
          console.error("❌ API Error:", err);
          // Revert the toggle on error
          product.visible = !product.visible;
          this.toastr.error("Error updating product visibility");
        },
      );
  }

  toggleProductFeatured(product: any) {
    console.log("🚀 Toggling featured for product:", product._id);
    console.log("🚀 New isFeatured value:", product.isFeatured);

    // Create proper request body
    const body = {
      isFeatured: product.isFeatured,
    };

    this.apiCallingService
      .callAPI(
        body,
        "POST",
        ConfigApi.URLS.VENDING.TOGGLE_FEATURED + "/" + product._id,
      )
      .subscribe(
        (res) => {
          console.log("✅ API Response:", res);
          if (this.apiCallingService.handleSuccess(res)) {
            const status = product.isFeatured ? "featured" : "unfeatured";
            this.toastr.success(`Product ${status} successfully`);
          }
        },
        (err) => {
          console.error("❌ API Error:", err);
          // Revert the toggle on error
          product.isFeatured = !product.isFeatured;
          this.toastr.error("Error updating product featured status");
        },
      );
  }

  toggleProductCampaign(product: any) {
    console.log("🚀 Toggling campaign for product:", product._id);
    console.log("🚀 New isFeatured value:", product.isFeatured);

    // Create proper request body
    const body = {
      isCampaign: product.isCampaign,
    };

    this.apiCallingService
      .callAPI(
        body,
        "POST",
        ConfigApi.URLS.VENDING.TOGGLE_CAMPAIGN + "/" + product._id,
      )
      .subscribe(
        (res) => {
          console.log("✅ API Response:", res);
          if (this.apiCallingService.handleSuccess(res)) {
            const status = product.isCampaign ? "campaign" : "uncampaign";
            this.toastr.success(`Product ${status} successfully`);
          }
        },
        (err) => {
          console.error("❌ API Error:", err);
          // Revert the toggle on error
          product.isCampaign = !product.isCampaign;
          this.toastr.error("Error updating product campaign status");
        },
      );
  }

  toggleFestiveBox(product: any) {
    console.log("🚀 Toggling FestiveBox for product:", product._id);
    console.log("🚀 New isFeatured value:", product.isFeatured);

    // Create proper request body
    const body = {
      isFestiveBox: product.isFestiveBox,
    };

    this.apiCallingService
      .callAPI(
        body,
        "POST",
        ConfigApi.URLS.VENDING.TOGGLE_FESTIVE_BOX + "/" + product._id,
      )
      .subscribe(
        (res) => {
          console.log("✅ API Response:", res);
          if (this.apiCallingService.handleSuccess(res)) {
            const status = product.isFestiveBox
              ? "festive box"
              : "not festive box";
            this.toastr.success(`Product ${status} successfully`);
          }
        },
        (err) => {
          console.error("❌ API Error:", err);
          // Revert the toggle on error
          product.isFestiveBox = !product.isFestiveBox;
          this.toastr.error("Error updating product festive box status");
        },
      );
  }

  ngOnDestroy() {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
    if (this.map) {
      this.map.remove();
    }
  }

  getCategoryName(id: string) {
    const category = this.categoryList?.find((c: any) => c._id === id);
    return category ? category.category_name : id;
  }
}
